/**
 * ESTADOS DEL PEDIDO (Gestión Administrativa y Base de Datos)
 */
const ESTADOS_PEDIDO = {
  PENDIENTE: 'pendiente',
  PROCESANDO: 'procesando',
  ASIGNADO: 'asignado',
  CONFIRMADO: 'confirmado',
  LISTO: 'listo',
  EN_RUTA: 'en_ruta',
  EN_PROCESO: 'en_proceso',
  COMPLETADO: 'completado',
  CERRADO: 'cerrado',
  CERRADO_POR_CLIENTE: 'cerrado_por_cliente',
  RECHAZADO: 'rechazado'
};

/**
 * ESTADOS DEL DELIVERY (Logística de motorizados)
 */
const ESTADOS_DELIVERY = {
  LISTO_PARA_RECOGER: 'listo_para_recoger',   
  EN_TIENDA: 'en_tienda',                     
  EN_RUTA: 'en_ruta_delivery',                
  COMPLETADO_DELIVERY: 'completado_delivery'  
};

/**
 * ESTADOS DEL FLUJO DEL CHAT (Lógica de Lina)
 */
const ESTADOS_FLUJO_CHAT = {
  SALUDO: 'SALUDO',
  SELECCIONAR_CATEGORIA: 'SELECCIONAR_CATEGORIA',
  SELECCIONAR_PRODUCTO: 'SELECCIONAR_PRODUCTO',
  SELECCIONAR_CANTIDAD: 'SELECCIONAR_CANTIDAD',
  CONFIRMAR_AGREGAR: 'CONFIRMAR_AGREGAR',
  CONFIRMAR_ENVIO: 'CONFIRMAR_ENVIO',
  PEDIR_UBICACION: 'PEDIR_UBICACION',
  PEDIR_NOMBRE: 'PEDIR_NOMBRE',
  PEDIR_TELEFONO: 'PEDIR_TELEFONO',
  METODO_PAGO: 'METODO_PAGO',
  ESPERANDO_CONFIRMACION_ADMIN: 'ESPERANDO_CONFIRMACION_ADMIN',
  FINALIZADO: 'FINALIZADO'
};

const ESTADOS_VALIDOS = Object.values(ESTADOS_PEDIDO);
const ESTADOS_VALIDOS_DELIVERY = Object.values(ESTADOS_DELIVERY);
const ESTADOS_VALIDOS_CHAT = Object.values(ESTADOS_FLUJO_CHAT);

/**
 * AGRUPACIONES PARA VISTAS
 */
const GRUPOS_ESTADOS = {
  PENDIENTES: [
    ESTADOS_PEDIDO.PENDIENTE,
    ESTADOS_PEDIDO.CONFIRMADO,
    ESTADOS_PEDIDO.LISTO,
    ESTADOS_PEDIDO.EN_PROCESO,
    ESTADOS_PEDIDO.EN_RUTA,
    ESTADOS_PEDIDO.PROCESANDO,
    ESTADOS_PEDIDO.ASIGNADO
  ],
  COMPLETADOS: [
    ESTADOS_PEDIDO.COMPLETADO,
    ESTADOS_PEDIDO.CERRADO,
    ESTADOS_PEDIDO.CERRADO_POR_CLIENTE
  ],
  RECHAZADOS: [ESTADOS_PEDIDO.RECHAZADO]
};

/**
 * PERMISOS DE TRANSICIÓN (Seguridad)
 */
const ESTADOS_PERMITIDOS = {
  confirmarPrecio: [ESTADOS_PEDIDO.PENDIENTE, ESTADOS_PEDIDO.PROCESANDO],
  tomarPedido: [ESTADOS_PEDIDO.PENDIENTE],
  
  // 🔥 AGREGAMOS ESTADOS AQUÍ:
  marcarComoListo: [
    ESTADOS_PEDIDO.CONFIRMADO, 
    ESTADOS_PEDIDO.PROCESANDO, 
    'esperando_pago', // <--- Importante si el admin ya envió el precio
    'pago_confirmado' // <--- El estado después de verificar el voucher
  ],
  
  aceptarDelivery: [ESTADOS_PEDIDO.PENDIENTE, ESTADOS_PEDIDO.LISTO],
  confirmarEntrega: [ESTADOS_PEDIDO.EN_RUTA, ESTADOS_PEDIDO.EN_PROCESO, ESTADOS_PEDIDO.LISTO],
  confirmarRecepcion: [ESTADOS_PEDIDO.EN_RUTA, ESTADOS_PEDIDO.EN_PROCESO, ESTADOS_PEDIDO.LISTO,ESTADOS_DELIVERY.COMPLETADO_DELIVERY],
  cerrarAdmin: [ESTADOS_PEDIDO.CONFIRMADO, ESTADOS_PEDIDO.LISTO],
  cerrarCliente: [ESTADOS_PEDIDO.EN_RUTA, ESTADOS_PEDIDO.EN_PROCESO, ESTADOS_PEDIDO.LISTO,ESTADOS_DELIVERY.COMPLETADO_DELIVERY],
};
// ---------------------------------------------------------
// EXPORTACIÓN COMPATIBLE (Clave para evitar el error de Undefined)
// ---------------------------------------------------------

// 1. Exportación para Node.js (Backend)
if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    ESTADOS_PEDIDO,
    ESTADOS_DELIVERY,
    ESTADOS_FLUJO_CHAT,
    ESTADOS_VALIDOS,
    ESTADOS_VALIDOS_DELIVERY,
    ESTADOS_VALIDOS_CHAT,
    ESTADOS_PERMITIDOS,
    GRUPOS_ESTADOS,
  };
}

// 2. Exportación para ES Modules (Frontend/React)
export { 
  ESTADOS_PEDIDO, 
  ESTADOS_DELIVERY, 
  ESTADOS_FLUJO_CHAT,
  ESTADOS_VALIDOS,
  ESTADOS_VALIDOS_DELIVERY,
  ESTADOS_VALIDOS_CHAT,
  ESTADOS_PERMITIDOS,
  GRUPOS_ESTADOS
};